import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TeamService } from '../../models/team/team.service';

@Component({
    selector: 'app-add-team-dialog',
    templateUrl: './add-team-dialog.component.html',
    styleUrls: ['./add-team-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AddTeamDialogComponent {

    friendlyName: string;

    constructor(
    private teamService: TeamService,
    public dialogRef: MatDialogRef<AddTeamDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string
    ) {

    }

    save() {
        this.dialogRef.close(this.friendlyName);
    }

}
